import { DecreaseIcon, IncreaseIcon } from "icons";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";

export const CaptureCard = ({ item }) => {
  const Icon = item?.increase ? IncreaseIcon : DecreaseIcon;
  const PlatformIcon = item?.icon;

  return (
    <div
      className={styles.cardContainer}
      style={{ backgroundColor: item.bgColor }}
    >
      <div className={styles.titleIcon}>
        <div className={styles.title}>{item.title}</div>
        <ConditionalRenderer condition={item?.icon}>
          <div className={styles.iconContainer}>
            <PlatformIcon />
          </div>
        </ConditionalRenderer>
      </div>
      <div className={styles.values}>
        <div className={styles.value}>{item.value}</div>
        <div className={styles.percentage}>{item.percentage}</div>
      </div>
    </div>
  );
};
